import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-message-error",
  "use": "rt-base-message-error-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-message-error\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z\" p-id=\"2290\" fill=\"#F7734C\" /><path d=\"M512 660m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z\" p-id=\"2291\" fill=\"#F7734C\" /><path d=\"M482 572h60c5.5 0 10-3.2 10-7.1V323.1c0-3.9-4.5-7.1-10-7.1h-60c-5.5 0-10 3.2-10 7.1v241.8c0 3.9 4.5 7.1 10 7.1z\" p-id=\"2292\" fill=\"#F7734C\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/message-error.svg
// module id = 1272
// module chunks = 72